export const setRegistrationHash = (hash) => {
  window.sessionStorage.setItem("registration_hash", hash);
};

export const getRegistrationHash = () => {
  return window.sessionStorage.getItem("registration_hash");
};

export const removeRegistrationHash = () => {
  window.sessionStorage.removeItem("registration_hash");
};

export const setInvitationHash = (hash) => {
  window.sessionStorage.setItem("invitation_hash", hash);
};

export const getInvitationHash = () => {
  return window.sessionStorage.getItem("invitation_hash");
};

export const removeInvitationHash = () => {
  window.sessionStorage.removeItem("invitation_hash");
};
